import request from './request';
/**
 *  店铺累计到某一天的运营数据
 */
export function getOperationalData(params) {
    return request('/stat/dashboard/operational-data', {
        method: 'POST',
        params,
    });
}

/**
 *  15天注册安装率变化趋势
 */
export function getInstalledRegistered(params) {
    return request('/stat/dashboard/installed-registered-percent', {
        method: 'POST',
        params,
    });
}

/**
 *  7天事故回店率变化趋势
 */
export function getAccidentBack(params) {
    return request('/stat/dashboard/accident-back-percent', {
        method: 'POST',
        params,
    });
}

/**
 *  7天预约回店率变化趋势
 */
export function getAppointmentBack(params) {
    return request('/stat/dashboard/appointment-back-percent', {
        method: 'POST',
        params,
    });
}

/**
 *  获取首页待办任务总数
 */
export function getPendingCount(params) {
    return request('/stat/dashboard/pending-count', {
        method: 'GET',
        params,
    });
}

/**
 *  获取集团首页核心数据指标/回店过程分析
 */
export function getCoreData() {
    return request('/api/saas/group-board/core-data', {
        method: 'GET',
    });
}

/**
 *  获取集团首页碰撞救援数据TOP3
 */
export function getGroupBoardRank(params) {
    return request('/api/saas/group-board/rank', {
        method: 'GET',
        params,
    });
}

/**
 *  集团首页碰撞救援数据明细-查询城市
 */
export function getGroupBoardCitys() {
    return request('/api/saas/group-board/citys', {
        method: 'GET',
    });
}

/**
 *  集团首页碰撞救援数据明细-查询品牌
 */
export function getGroupBoardBrands() {
    return request('/api/saas/group-board/brands', {
        method: 'GET',
    });
}

/**
 *  获取集团首页碰撞救援数据明细
 */
export function getGroupBoardRankDetail(params) {
    return request('/api/saas/group-board/rank-detail', {
        method: 'GET',
        params,
    });
}

/**
 *  集团首页碰撞救援数据明细-导出
 */
// export function getGroupBoardRankDetailExport(params) {
//     return request('/api/saas/group-board/rank-detail/export', {
//         method: 'GET',
//         params,
//     });
// }
